import React from 'react';
import { ArrowForwardIos } from "@material-ui/icons";
const Arrows = () => <ArrowForwardIos fontSize={"inherit"} style={{marginLeft: '8px'}}/>
export default Arrows;